import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ArticleIcon from "@mui/icons-material/Article";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EmailIcon from "@mui/icons-material/Email";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import GroupsIcon from "@mui/icons-material/Groups";
import HomeIcon from "@mui/icons-material/Home";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import InboxIcon from "@mui/icons-material/Inbox";

/** Mockup-style: solid (filled) white icons, consistent size on navy sidebar */
export const CJ_NAV_ICON_SX = { fontSize: 22, color: "#fff" };

const LAYOUTS = {
  company: "/:CompanyUrl",
  staff: "/:CompanyUrl/staff-member",
  customer: "/:CompanyUrl/customers",
};

/**
 * Returns a MUI filled icon for CJ redesign nav rows, or null to fall back to route SVGs.
 */
export function getCjNavMuiIcon(prop, layout) {
  if (!prop || !layout) return null;
  if (prop.name === "Email" && prop.isCollapse) {
    return <EmailIcon sx={CJ_NAV_ICON_SX} />;
  }
  const p = prop.path || "";
  const I = (Icon) => <Icon sx={CJ_NAV_ICON_SX} />;

  if (layout === LAYOUTS.company) {
    const m = {
      "/index": HomeIcon,
      "/schedule": CalendarMonthIcon,
      "/customer": PeopleAltIcon,
      "/donor": PeopleAltIcon,
      "/service-requests": InboxIcon,
      "/quotes": RequestQuoteIcon,
      "/contract": ArticleIcon,
      "/invoice": ReceiptLongIcon,
      "/materials-labor": Inventory2Icon,
      "/manageteam": GroupsIcon,
      "/pos": PointOfSaleIcon,
      "/company-reports": AssessmentIcon,
      "/reports": AssessmentIcon,
      "/accept-donation": PointOfSaleIcon,
    };
    const Cmp = m[p];
    return Cmp ? I(Cmp) : null;
  }

  if (layout === LAYOUTS.staff) {
    const m = {
      "/index": DashboardIcon,
      "/worker-schedule": CalendarMonthIcon,
      "/worker-customer": PeopleAltIcon,
      "/worker-quote": RequestQuoteIcon,
      "/worker-contract": ArticleIcon,
      "/worker-invoice": ReceiptLongIcon,
      "/worker-invoice-detail": ReceiptLongIcon,
      "/worker-materials-labor": Inventory2Icon,
      "/worker-appointments": EventAvailableIcon,
      "/worker-time-entry": AccessTimeIcon,
      "/worker-reports": AssessmentIcon,
    };
    const Cmp = m[p];
    return Cmp ? I(Cmp) : null;
  }

  if (layout === LAYOUTS.customer) {
    const m = {
      "/index": DashboardIcon,
      "/customer-schedule": CalendarMonthIcon,
      "/quotes": RequestQuoteIcon,
      "/contract": ArticleIcon,
      "/invoice": ReceiptLongIcon,
      "/General-ledger": AccountBalanceIcon,
      "/appointment": EventAvailableIcon,
      "/notes": StickyNote2Icon,
    };
    const Cmp = m[p];
    return Cmp ? I(Cmp) : null;
  }

  return null;
}

/** Same glyphs as CJ sidebar nav; navy on white for "+ Create New" dropdown */
const CJ_CREATE_MENU_SX = {
  fontSize: 22,
  color: "rgb(6, 49, 100)",
  marginRight: "10px",
  flexShrink: 0,
};

const CREATE_MENU_ICONS = {
  customer: PeopleAltIcon,
  quote: RequestQuoteIcon,
  contract: ArticleIcon,
  invoice: ReceiptLongIcon,
};

export function CjCreateMenuIcon({ kind }) {
  const Cmp = CREATE_MENU_ICONS[kind];
  if (!Cmp) return null;
  return <Cmp sx={CJ_CREATE_MENU_SX} />;
}
